import { darken, lighten } from '@mui/material'
import { COLORS, DEFAULT_TONAL_OFFSET } from './colors'

export const lightTheme = {
    palette: {
        primary: {
            main: COLORS.theme.primary.dark,
            light: COLORS.theme.primary.light,
            dark: COLORS.theme.primary.dark,
            contrastText: COLORS.white
        },
        secondary: {
            light: COLORS.theme.secondary.light,
            main: COLORS.theme.secondary.main,
            dark: COLORS.theme.secondary.dark,
            contrastText: COLORS.white
        },
        error: {
            main: COLORS.theme.error_red.main,
            light: COLORS.theme.error_red.light,
            dark: COLORS.theme.error_red.dark,
            contrastText: COLORS.white
        },
        warning: {
            main: COLORS.theme.warning_yellow.main,
            light: COLORS.theme.warning_yellow.light,
            dark: COLORS.theme.warning_yellow.dark,
            contrastText: COLORS.white
        },
        background: {
            default: darken(COLORS.white, 0.01)
        },
        text: {
            primary: lighten(COLORS.black, DEFAULT_TONAL_OFFSET),
            secondary: lighten(COLORS.black, 0.5)
        },
        mode: 'light' as 'light'
    },
    shape: {
        borderRadius: 6
    },
    sidebar: {
        width: 220
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    minWidth: '2rem'
                },
                contained: {
                    backgroundColor: COLORS.white,
                    color: COLORS.black,
                    boxShadow: 'none',

                    '&:hover': {
                        backgroundColor: COLORS.theme.primary.light,
                        boxShadow: 'none'
                    }
                },
                containedPrimary: {
                    color: COLORS.white,
                    backgroundColor: COLORS.theme.primary.dark,
                    boxShadow: 'none',

                    '&:hover': {
                        backgroundColor: COLORS.theme.primary.main,
                        boxShadow: 'none',
                        color: COLORS.black
                    }
                },
                containedWarning: {
                    backgroundColor: COLORS.theme.warning_yellow.main,

                    '&:hover': {
                        backgroundColor: COLORS.theme.warning_yellow.dark,
                        color: COLORS.black
                    }
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    width: '100%',
                    marginTop: 0,
                    bottom: 0
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    backgroundColor: COLORS.white,
                    borderRight: `0.1rem solid ${COLORS.theme.secondary.light}`
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                elevation1: {
                    boxShadow: 'none'
                },
                root: {
                    border: `0.1rem solid ${COLORS.theme.secondary.light}`,
                    backgroundClip: 'padding-box'
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&:hover:active::after': {
                        // recreate a static ripple color
                        // use the currentColor to make it work both for outlined and contained buttons
                        // but to dim the background without dimming the text,
                        // put another element on top with a limited opacity
                        content: '""',
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3,
                        borderRadius: 'inherit'
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: COLORS.theme.primary.dark
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                colorSecondary: {
                    color: lighten(COLORS.black, 0.5),
                    backgroundColor: COLORS.white
                },
                root: {
                    '& .MuiToolbar-root': {
                        backgroundColor: COLORS.theme.secondary.light
                    }
                }
            }
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    border: 'none',
                    justifyContent: 'center',
                    alignSelf: 'center'
                },
                message: {
                    color: COLORS.white
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 'bold'
                }
            }
        }
    }
}
